type ServiceDetails = {
  service: string;
  helpType: string;
  supportType: string;
  deviceTypes: string[];
  operatingSystems: string[];
  problem: string;
  additionalProblem?: string;
};

export const extractServiceDetails = (serviceDescription: string | undefined = ''): ServiceDetails => {
  const serviceDetails: Partial<ServiceDetails> = {};
  const deviceTypes: string[] = [];
  const operatingSystems: string[] = [];

  const serviceMatch = serviceDescription.match(/Service:\s*(.*)/);
  const helpTypeMatch = serviceDescription.match(/Help Type:\s*(.*)/);
  const supportTypeMatch = serviceDescription.match(/Support Type:\s*(.*)/);
  const additionalProblemMatch = serviceDescription.match(/Additional Problem:\s*(.*)/);

  const deviceTypeSection = serviceDescription.match(/Device Type\(s\):(.*?)Operating System:/s);
  if (deviceTypeSection) {
    const devices = deviceTypeSection[1].trim().split('\n');
    devices.forEach((line) => {
      const device = line.replace('-', '').trim();
      if (device) deviceTypes.push(device);
    });
  }

  const osSection = serviceDescription.match(/Operating System:(.*?)Problem:/s);
  if (osSection) {
    const systems = osSection[1].trim().split('\n');
    systems.forEach((line) => {
      const os = line.replace('-', '').trim();
      if (os) operatingSystems.push(os);
    });
  }

  const problemMatch = serviceDescription.match(/Problem:(.*?)(?:Additional Problem:|Payment method:)/is);

  serviceDetails.problem = problemMatch?.[1].trim() || '';
  serviceDetails.service = serviceMatch?.[1].trim() || '';
  serviceDetails.helpType = helpTypeMatch?.[1].trim() || '';
  serviceDetails.supportType = supportTypeMatch?.[1]?.trim() || '';
  serviceDetails.deviceTypes = deviceTypes;
  serviceDetails.operatingSystems = operatingSystems;
  serviceDetails.additionalProblem = additionalProblemMatch?.[1].trim() || '';

  return serviceDetails as ServiceDetails;
};

export const mapOperatingSystemsToLabels = (OSLabels: Record<string, string>, operatingSystems: string[]): string[] => {
  return operatingSystems.map((os) => {
    const key = os.toLowerCase().replace(/\s+/g, '_');
    return OSLabels[key] || `Unknown OS: ${os}`;
  });
};
